module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAO5JREFUOE+tlDFuwkAQRd+HLlVOgDgABU3qJCeJhMQ5MNegiMRJcE4SN1Gk9GlSMOysGMkUxtmFkdx4rTf//5m1uFPJOWb2DLxUMltJHwHaJEhTCWokbQM0B/ypqU5Sd3dFYe21UNLBI+lby6D0IhROgZmkz/MwHoFlr0m2Y2Y2CDKzhzTBFvhN08gKzcwn6t2jsoox0BrYOawHqlIUoOj+BSxusfYE/AErwGFl1s6ZeNiu4lvSj5mVWysZ/2DYFdfEr9XFHr2lvXkHJiWKgKNnKGmfF/BapT9DDjlWYejb/4BcrYP21xqOgsYUx/kJQYqjE3te8w0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/patrolScreen.png
// module id = b1bB
// module chunks = 0